<template>
  <vx-card no-shadow>

    <vs-input class="w-full mb-base" icon="icon-twitter" icon-no-border icon-pack="feather" label="GitHub" v-model="twitter"/>
    <vs-input class="w-full mb-base" icon="icon-facebook" icon-no-border icon-pack="feather" label="GitHub" v-model="facebook"/>
    <vs-input class="w-full mb-base" icon="icon-instagram" icon-no-border icon-pack="feather" label="GitHub" v-model="instagram"/>
    <vs-input class="w-full mb-base" icon="icon-github" icon-no-border icon-pack="feather" label="GitHub" v-model="github"/>
    <vs-input class="w-full mb-base" icon="icon-linkedin" icon-no-border icon-pack="feather" label="GitHub" v-model="linkedin"/>
    <vs-input class="w-full mb-base" icon="icon-slack" icon-no-border icon-pack="feather" label="GitHub" v-model="slack"/>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2">Save Changes</vs-button>
      <vs-button class="ml-4 mt-2" color="warning" type="border">Reset</vs-button>
    </div>
  </vx-card>
</template>

<script>
  export default {
    data ()
    {
      return {
        twitter:   'https://twitter.com/adoptionism744',
        facebook:  'https://www.facebook.com/adoptionism664',
        instagram: 'https://www.instagram.com/adopt-ionism744/',
        github:    'https://github.com/madop818',
        linkedin:  'https://codepen.io/adoptism243',
        slack:     '@adoptionism744'
      }
    },
    computed: {
      activeUserInfo ()
      {
        return this.$store.state.AppActiveUser
      }
    }
  }
</script>
